import { render, staticRenderFns } from "./ScrollPrompt.vue?vue&type=template&id=5328d2c5&"
import script from "./ScrollPrompt.vue?vue&type=script&lang=js&"
export * from "./ScrollPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports